import {
    AnySelection,
    AnySeries,
    seriesSvgCandlestick,
} from '@d3fc/d3fc-series';
import { deriveTime, TimeSeriesChartDataItem } from './TimeSeriesChartData';

export const candlestick = <T>(
    openValue: (d: T) => number | undefined,
    highValue: (d: T) => number | undefined,
    lowValue: (d: T) => number | undefined,
    closeValue: (d: T) => number | undefined,
    className: string,
    crossValue: (d: T) => number | undefined
): AnySeries =>
    seriesSvgCandlestick()
        .crossValue(crossValue)
        .openValue(openValue)
        .highValue(highValue)
        .lowValue(lowValue)
        .closeValue(closeValue)
        .decorate((selection: AnySelection) => {
            selection.classed(className, true);
        });

export const timeSeriesCandlestick = <T extends TimeSeriesChartDataItem>(
    openValue: (d: T) => number | undefined,
    highValue: (d: T) => number | undefined,
    lowValue: (d: T) => number | undefined,
    closeValue: (d: T) => number | undefined,
    className: string,
    crossValue: (d: T) => number | undefined = deriveTime
): AnySeries =>
    candlestick<T>(
        openValue,
        highValue,
        lowValue,
        closeValue,
        className,
        crossValue
    );
